// Imports
import { useEffect } from 'react';
import { useAppSelector } from '../../../shareables/foundation/front-end/redux/hooks';


// Extend interface
declare global {
	interface Window {
		dataLayer: unknown[];
		gtag: (...args: unknown[]) => void;
	}
}


// Function component
const GoogleAnalytics = () => {
	// Use Redux functionality
	const identifier = useAppSelector((state) => state.self.website?.googleAnalyticsIdentifier);
	
	
	// Load Google Analytics script
	useEffect(() => {
		if (!identifier) {
			return;
		}
		
		window.dataLayer = window.dataLayer || [];
		
		if (typeof window.gtag !== 'function') {
			window.gtag = function gtag() {
				// eslint-disable-next-line prefer-rest-params
				window.dataLayer.push(arguments);
			};
			
			window.gtag('js', new Date(Date.now()));
		}
		
		window.gtag('config', identifier);
		
		const script = document.createElement('script');
		script.async = true;
		script.src = `https://www.googletagmanager.com/gtag/js?id=${identifier}`;
		
		const firstScript = document.getElementsByTagName('script')[0];
		firstScript.parentNode?.insertBefore(script, firstScript);
		
		return () => {
			script.remove();
		};
	}, [identifier]);
	
	
	// Render nothing
	return null;
};

export default GoogleAnalytics;
